import FinalCalculation from './FinalCalculation';
import Item from './Item';
import Reference from './Reference';

export default class AeMaxPrice {
	reference: Reference;

	finalCalculation: FinalCalculation;

	products: Item[];

	links: { [key: string]: string };

	constructor(
		reference: Reference,
		finalCalculation: FinalCalculation,
		products: Item[],
		links: { [key: string]: string }
	) {
		this.reference = reference;
		this.finalCalculation = finalCalculation;
		this.products = products;
		this.links = links;
	}

	getExportXlsLink(): string {
		return this.links['export-xls'];
	}
}
